<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :color="color" :style="btnStyle" :class="btnClass" small
        @click.prevent="handleClick">
        <slot>
          <v-icon>mdi-help-circle</v-icon>
        </slot>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "TooltipBtn",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    btnClass: {
      type: String,
      default: ""
    },
    btnStyle: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }
  }
};
</script>
<style scoped>
.btnsave {
  background-color: #00a178 !important;
  color: white;
}
</style>